import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Projects`}</h2>
    <ProjectCard title="Python Game Dev" link="https://github.com/prajjwaldatir/coronastrike" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
Corona Strike is a Python Pygame based 2D Game.
    </ProjectCard>
    <ProjectCard title="Python3 Socket" link="https://github.com/PrajjwalDatir/HTTP-Prajjwal" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
HTTP Protocol Implemented Using Socket Programming.
    </ProjectCard>
    <ProjectCard title="Database MySQL " link="https://github.com/PrajjwalDatir/Primary-School-Management-System" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
School Management System.
    </ProjectCard>
    <ProjectCard title="Gatsby Web Dev" link="https://github.com/PrajjwalDatir/PrajjwalDatir.github.io" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
Portfolio Website Made using Gateby.
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      